import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

const Copyright = () => {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.krispis.mx/">
                Krispis
            </Link>
            {` ${new Date().getFullYear()}.`}
        </Typography>
    );
};

export default Copyright;
